<template>
  <div>
    <div class="row field-row-1">
      <div class="col-4">
        <label>Description/label</label>
        <ValidationProvider name="Value" rules="required" v-slot="{ errors }">
          <input type="text" class="form-control bold" v-model="f.title" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-3">
        <label class="fw-bold">Field name</label>
        <ValidationProvider
          name="Field"
          rules="required|alpha_num"
          v-slot="{ errors }"
        >
          <input type="text" class="form-control" v-model="f.field" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-3">
        <label>Type</label>
        <ValidationProvider name="Type" rules="required" v-slot="{ errors }">
          <select class="form-control" v-model="f.type">
            <option value="int">Whole/integer number</option>
            <!-- <option value="float">Decimal number</option> -->
            <option value="select">Selection list</option>
            <!-- <option value="text">Text</option> -->
          </select>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label>Mandatory</label>
        <input type="checkbox" class="d-block" v-model="f.required" />
      </div>
    </div>
    <!-- FIELD WHOLE NUMBER -->
    <div class="row field-row-2" v-if="f.type === 'int'">
      <div class="col-2">
        <label>Default value</label>
        <ValidationProvider
          name="Value"
          :rules="
            'required|min_value:' + f.min_value + '|max_value:' + f.max_value
          "
          v-slot="{ errors }"
        >
          <input type="number" class="form-control" v-model="f.default" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label>Minimum</label>
        <ValidationProvider
          name="Value"
          :rules="'required|max_value:' + f.max_value"
          v-slot="{ errors }"
        >
          <input type="number" class="form-control" v-model="f.min_value" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label>Units <small>(e.g. mm)</small></label>
        <ValidationProvider
          name="Value"
          rules="required"
          v-slot="{ errors }"
        >
          <input type="text" class="form-control" v-model="f.units" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-2">
        <label>Maximum</label>
        <ValidationProvider
          name="Value"
          :rules="'required|min_value:' + f.min_value"
          v-slot="{ errors }"
        >
          <input type="number" class="form-control" v-model="f.max_value" />
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </div>

    <!-- FIELD SELECT -->
    <div class="row field-row-2" v-if="f.type === 'select'">
      <div class="col-3">
        <label>Default value/preview</label>
        <ValidationProvider
          name="Default value"
          :rules="f.required ? 'required' : ''"
          v-slot="{ errors }"
        >
          <select class="form-control" v-model="f.default">
            <option v-for="o in f.options" :value="o.key" :key="o.key">
              {{ o.text }}
            </option>
          </select>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div class="col-9">
        <div class="row">
          <div class="col-7">
            <label>Option description/label</label>
          </div>
          <div class="col-4">
            <label>Option value</label>
          </div>
        </div>
        <div
          class="row mt-3"
          v-for="(o, optionsIndex) in f.options"
          :key="optionsIndex"
        >
          <div class="col-7">
            <ValidationProvider
              name="Description"
              rules="required"
              v-slot="{ errors }"
            >
              <input type="text" class="form-control" v-model="o.text" />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-4">
            <ValidationProvider name="Key" rules="required" v-slot="{ errors }">
              <input type="text" class="form-control" v-model="o.key" />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div class="col-1">
            <button
              type="button"
              class="btn btn-link text-danger"
              @click.prevent="handleDelArrayElement(f.options, optionsIndex)"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <button
              type="button"
              class="btn btn-link"
              @click.prevent="handleAddOption()"
            >
              Add option
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: Object,
  },
  computed: {
    f: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    handleDelArrayElement(arr, index) {
      arr = arr.splice(index, 1);
    },
    handleAddOption() {
      if (!this.f.options) {
        this.f.options = [];
      }
      this.f.options.push({ key: "", value: "" });
      this.$forceUpdate();
    },
  },
};
</script>